import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    // Pour les fichiers statiques importants, rediriger vers l'URL correcte
    if (location.pathname === '/sitemap.xml') {
      window.location.href = '/sitemap.xml';
      return;
    }
    
    if (location.pathname === '/robots.txt') {
      window.location.href = '/robots.txt';
      return;
    }
    
    if (location.pathname === '/apple-touch-icon.png') {
      window.location.href = '/apple-touch-icon.png';
      return;
    }

    // Ne pas logger les erreurs pour les fichiers statiques
    const staticFiles = ['/sitemap.xml', '/robots.txt', '/apple-touch-icon.png', '/favicon.ico'];
    if (!staticFiles.includes(location.pathname) && !location.pathname.match(/\.(xml|txt|png|jpg|ico|css|js)$/)) {
      console.error(
        "404 Error: User attempted to access non-existent route:",
        location.pathname
      );
    }
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-4">Oops! Page not found</p>
        <a href="/" className="text-blue-500 hover:text-blue-700 underline">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
